import { useState } from 'react';
import type { Key } from 'react-aria-components';
import { PaymentOption, ValidationSectionKey } from '@/constants';
import { useCheckout } from '@/contexts/checkoutContext';
import { useValidation } from '@/contexts/validationContext';
import { useDataLayer } from '@/hooks/useDataLayer';
import * as Styled from './PaymentOptions.styled';
import { usePageData } from '../../contexts/pageContext';

export const PaymentOptions = () => {
  const { checkoutData, setPaymentOption } = useCheckout();
  const { clearValidationError, errorMessages } = useValidation();
  const { addPaymentInfo } = useDataLayer();
  const { isPayPalEnabled } = usePageData();
  const [selectedPaymentOption, setSelectedPaymentOption] = useState<Set<Key>>(
    new Set([]),
  );

  const paymentMethodError = errorMessages[ValidationSectionKey.PaymentMethod];

  const handleSelection = (set: Set<Key>) => {
    if (set.size > 0) {
      setSelectedPaymentOption(set);
      clearValidationError(ValidationSectionKey.PaymentMethod);

      const paymentOption = Array.from(set)[0];

      if (paymentOption === PaymentOption.CreditCard) {
        addPaymentInfo('Credit Card', checkoutData.items || []);
        setPaymentOption(paymentOption);
      } else if (paymentOption === PaymentOption.PayPal) {
        addPaymentInfo('PayPal', checkoutData.items || []);
        setPaymentOption(paymentOption);
      }
    }
  };

  return (
    <Styled.Group
      className={paymentMethodError ? 'has-validation-error' : undefined}
      data-validation-key={ValidationSectionKey.PaymentMethod}
      expandedKeys={selectedPaymentOption}
      onExpandedChange={handleSelection}
    >
      {paymentMethodError ? (
        <Styled.ErrorText>{errorMessages.paymentMethod}</Styled.ErrorText>
      ) : null}
      <Styled.Option id={PaymentOption.CreditCard}>
        <Styled.Trigger slot="trigger">
          <Styled.RadioButton />
          <Styled.Label>Debit / Credit Card</Styled.Label>
          <img
            loading="lazy"
            src="/Styles/Images/CreditCards1.png"
            alt="Visa, MasterCard, Maestro and Diners Club logos"
          />
        </Styled.Trigger>
        <Styled.Panel>
          <div id="credit-card-form">
            {/* The SagePay credit card form will be inserted here. */}
          </div>
        </Styled.Panel>
          </Styled.Option>
          {isPayPalEnabled ? (
        <Styled.Option id={PaymentOption.PayPal}>
        <Styled.Trigger slot="trigger">
          <Styled.RadioButton />
          <Styled.Label>PayPal</Styled.Label>
          <img
            loading="lazy"
            src="/Styles/Images/PaypalLogo.png"
            alt="PayPal logo"
          />
        </Styled.Trigger>
        <Styled.Panel>
          <p>
            After clicking "Pay now", you will be redirected to PayPal to
            complete your purchase securely.
          </p>
        </Styled.Panel>
              </Styled.Option>
          ) : null}
    </Styled.Group>
  );
};
